import { render, staticRenderFns } from "./SvgImport.vue?vue&type=template&id=c93129de&"
import script from "./SvgImport.vue?vue&type=script&lang=js&"
export * from "./SvgImport.vue?vue&type=script&lang=js&"
import style0 from "./SvgImport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports